import $ from "jquery";

$(document).ready(function () {
  var open_long_description = () => {
    $(document).ready(function () {
      // Set initial height for all expand columns
      $(".expand-column").each(function() {
        $(this).css("height", "auto");
        $(this).find('.expand-column_content').css("height", "45px");
      });
      $(".expand-column").on("click", function () {
        if($(this).hasClass('opened')) {
          $(this).removeClass('opened');
          $(this).animate({height:"auto"},500);
          $(this).find('.expand-column_content').animate({height:45},200);
        } else { 
          $(this).animate({height:"auto"},500).addClass('opened');
          const scrollHeight = $(this).find('.expand-column_content')[0].scrollHeight;
          $(this).find('.expand-column_content').animate({height:scrollHeight},200);
        }
      });

      $(".expand-column_close-icon").on("click", function () {
        $(this).closest(".expand-column");
      });
    });
  };

  try {
    open_long_description();
    // open_attachment();
  } catch (error) {
    console.log(error);
  }
});
